import React, { useEffect } from 'react';
import reqProvider from '../../util/requests/reqProvider';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography, useMediaQuery, useTheme,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { nextStep } from '../../reducers/companyRegistrationStep/stepperSlice';
import { setSelectedCompany } from '../../reducers/companyRegistrationStep/selectedCompanySlice';
import { RootState } from '../../globalStore/store'

interface Company {
  id: number;
  name: string;
}

interface Props {
  setRegistered: (value: boolean) => void;
}

const RegisteredCompanies: React.FC<Props> = ({ setRegistered }) => {
  const [companies, setCompanies] = React.useState<Company[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const dispatch = useDispatch();
  const selectedCompany = useSelector((state: RootState) => state.selectedCompany.selectedCompany);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    reqProvider.get('company')
      .then(res => {
        setCompanies(res.data.content);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  return (
    isLoading ?
      <Box textAlign={'center'} sx={{ marginY: '50px' }}>
        <CircularProgress />
      </Box>
      :
      <Box width={isSmallScreen ? '100%' : 350}>
        <Box sx={{ marginY: '20px', maxHeight: isSmallScreen ? 'none' : '600px', overflowY: isSmallScreen ? 'visible' : 'auto' }}>
          <Typography sx={{ marginBottom: '10px' }}>{'Regisztrált cégek:'}</Typography>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              onChange={(e) => dispatch(setSelectedCompany(parseInt(e.target.value)))}
            >
              {companies?.map((company, index) => (
                <>
                  <FormControlLabel value={company.id} key={company.id} control={<Radio />} label={company.name} />
                  {index + 1 !== companies.length && <hr style={{ width: '100%' }} />}
                </>
              ))}
            </RadioGroup>
          </FormControl>
        </Box>
        <Button sx={{ marginY: '10px' }} onClick={() => {
          dispatch(nextStep());
        }} disabled={!selectedCompany} variant={'contained'}>{'Tovább az üzleti egységre'}</Button>
        <Button variant={'text'} onClick={() => {
          setRegistered(false);
        }}>{'+ Új céget adok hozzá'}</Button>
      </Box>
  );
};

export default RegisteredCompanies;